/**
 * CARTO Basemaps Tile URL Builder
 * Appends the required CARTO API key to prevent the "API KEY REQUIRED" watermark.
 */
export type CartoBasemapStyle =
  | 'dark_all'
  | 'light_all'
  | 'rastertiles/voyager'
  | 'rastertiles/voyager_labels_under'
  | 'rastertiles/voyager_nolabels'
  | 'rastertiles/voyager_only_labels'
  | (string & {});

const FALLBACK_CARTO_API_KEY = 'cb1_2hg4_1_16e1ca5cff22f57114eef495';

export const getCartoApiKey = (): string => {
  return import.meta.env?.VITE_CARTO_API_KEY || FALLBACK_CARTO_API_KEY;
};

export const getCartoTileUrl = (
  style: CartoBasemapStyle = 'light_all',
  apiKey: string = getCartoApiKey()
): string => {
  const keyParam = apiKey ? `?key=${encodeURIComponent(apiKey)}` : '';
  return `https://{s}.basemaps.cartocdn.com/${style}/{z}/{x}/{y}{r}.png${keyParam}`;
};
